import { combineReducers } from 'redux';

import { reducer as widgetsReducer } from './widgets/reducer';

export const reducer = combineReducers({
  widgets: widgetsReducer,
});